<template>
    <div class="container-fluid">
        <form
            class="form"
            @submit.prevent="createUser()"
        >
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group">
                                <label for="name">Full name:</label>
                                <input
                                    type="text"
                                    id="name"
                                    placeholder="Full name"
                                    v-model="user.name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.name }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.name"
                                >{{ errors.name[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="email">Email address:</label>
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Email address"
                                    v-model="user.email"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.email }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.email"
                                >{{ errors.email[0] }}</small>
                            </div>
                            <div class="row">
                                <div class="form-group col-sm-6">
                                    <label for="password">Password:</label>
                                    <input
                                        type="password"
                                        id="password"
                                        placeholder="Password"
                                        v-model="user.password"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.password }"
                                    >
                                    <small
                                        class="form-error"
                                        v-if="errors.password"
                                    >{{ errors.password[0] }}</small>
                                </div>
                                <div class="form-group col-sm-6">
                                    <label for="password_confirmation">Confirm password:</label>
                                    <input
                                        type="password"
                                        id="password_confirmation"
                                        placeholder="Confirm password"
                                        v-model="user.password_confirmation"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.password_confirmation }"
                                    >
                                    <small
                                        class="form-error"
                                        v-if="errors.password_confirmation"
                                    >{{ errors.password_confirmation[0] }}</small>
                                </div>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="office_access"
                                    v-model="user.office_access"
                                    class="form-control form-check-input"
                                    value="1"
                                >
                                <label
                                    class="form-check-label"
                                    for="office_access"
                                >Office access</label>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="engineer_access"
                                    v-model="user.engineer_access"
                                    class="form-control form-check-input"
                                    value="1"
                                >
                                <label
                                    class="form-check-label"
                                    for="engineer_access"
                                >Engineer access</label>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="admin_access"
                                    v-model="user.admin_access"
                                    class="form-control form-check-input"
                                    value="1"
                                >
                                <label
                                    class="form-check-label"
                                    for="admin_access"
                                >Admin access</label>
                            </div>
                            <div class="form-group form-check">
                                <input
                                    type="checkbox"
                                    id="receive_kpi_reports"
                                    v-model="user.receive_kpi_reports"
                                    class="form-control form-check-input"
                                    value="1"
                                >
                                <label
                                    class="form-check-label"
                                    for="receive_kpi_reports"
                                >Receive KPI Reports via Email</label>
                            </div>
                            <div class="form-group">
                                <label for="annual_leave_allowance">Annual Leave Allowance (Days):</label>
                                <input
                                    type="number"
                                    step="0.5"
                                    min="0"
                                    id="annual_leave_allowance"
                                    v-model="user.annual_leave_allowance"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.annual_leave_allowance }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.annual_leave_allowance"
                                >{{ errors.annual_leave_allowance[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="order">Order:</label>
                                <input
                                    type="number"
                                    id="order"
                                    v-model="user.order"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.order }"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.order"
                                >{{ errors.order[0] }}</small>
                            </div>
                            <div class="form-group">
                                <button
                                    type="submit"
                                    class="btn btn-primary"
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    @click="$router.go(-1)"
                                    class="btn btn-outline-secondary"
                                >
                                    Back
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import UsersService from "../../../../services/UsersService";

export default {
    data: function() {
        return {
            user: {
                name: "",
                email: "",
                password: "",
                office_access: false,
                engineer_access: false,
                admin_access: false,
                order: 0,
            },
            errors: {},
        };
    },

    methods: {
        createUser: function() {
            this.errors = {};
            UsersService
                .create(this.user)
                .then(xhr => {
                    this.user = xhr.data;
                    alert('User saved');
                    this.$router.push({ name: 'admin.users' });
                })
                .catch(error => {
                    alert('Error: Failed to save the user');
                    this.errors = error.response.data.errors;
                });
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/admin/users/UserAddComponent.vue